/** Default vertical lane spacing (px) — keep in sync with InvestigationNetworkFlow. */
export const INV_PARALLEL_EDGE_LANE_PX = 32;

/**
 * When multiple edges connect the same node pair (primary parent link + supplemental graph links),
 * assign a vertical lane offset so paths and labels do not stack on top of each other.
 */
export function annotateParallelEdges(edges, laneSpacingPx = INV_PARALLEL_EDGE_LANE_PX) {
  if (!edges?.length) return [];
  const indicesByPair = new Map();
  edges.forEach((e, i) => {
    const key = `${e.source}>>${e.target}`;
    if (!indicesByPair.has(key)) indicesByPair.set(key, []);
    indicesByPair.get(key).push(i);
  });
  return edges.map((e, i) => {
    const key = `${e.source}>>${e.target}`;
    const group = indicesByPair.get(key) || [i];
    const parallelCount = group.length;
    if (parallelCount <= 1) return e;
    const parallelIndex = group.indexOf(i);
    const parallelLaneOffset =
      (parallelIndex - (parallelCount - 1) / 2) * laneSpacingPx;
    return {
      ...e,
      data: {
        ...e.data,
        parallelIndex,
        parallelCount,
        parallelLaneOffset,
      },
    };
  });
}
